// src/golive/components/ui/FileUpload.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx
// (theme="tailwind", multiple=true — the mode this component originated).
import FileDropzone from "../../../shared/ui/FileDropzone";
import { MAX_TOTAL_UPLOAD_SIZE, ALLOWED_EXTENSIONS } from "../../constants";

export default function FileUpload({ files, onChange }) {
  return (
    <FileDropzone
      theme="tailwind"
      multiple
      accept={ALLOWED_EXTENSIONS}
      maxTotalSize={MAX_TOTAL_UPLOAD_SIZE}
      files={files}
      onChange={onChange}
    />
  );
}
